export default __webpack_public_path__ + "static/media/Segoe-UI-Bold.b00928e6.ttf";